import React, { useEffect, useState } from 'react';
import SplashScreen from '~/components/views/SplashScreen/SplashScreen';

interface Props {
  msec?: number;
}

const DelayedSplashScreen: React.FC<Props> = ({ msec = 300 }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, msec);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  });

  if (!isVisible) {
    return null;
  }

  return <SplashScreen />;
};

export default DelayedSplashScreen;
